import { BaseModel, type RelationConfig } from './base';

// Helper Classes

export class ReportFilterValue extends BaseModel {
  active!: boolean;
}

export class ReportFilter extends BaseModel {
  values!: ReportFilterValue[];

  static override relations(): RelationConfig {
    return {
      values: { type: ReportFilterValue },
    };
  }

  get value(): ReportFilterValue | undefined {
    return this.values?.find((option: ReportFilterValue) => option.active);
  }
}

export class ReportSectionLineLink extends BaseModel {}

export class ReportSectionLine extends BaseModel {
  links!: ReportSectionLineLink[];

  static override relations(): RelationConfig {
    return {
      links: { type: ReportSectionLineLink },
    };
  }
}

export class ReportSection extends BaseModel {
  lines!: ReportSectionLine[];

  static override relations(): RelationConfig {
    return {
      lines: { type: ReportSectionLine },
    };
  }
}

export class ReportSummaryItem extends BaseModel {}
export class ReportSummaryHeroItem extends BaseModel {}
export class ReportSummaryLink extends BaseModel {}
export class ReportDates extends BaseModel {}
export class ReportDateScope extends BaseModel {}

export class ReportInfo extends BaseModel {}

// Main Model

export class Report extends BaseModel {
  filters!: ReportFilter[];
  summaryItems!: ReportSummaryItem[];
  summaryHeroItems!: ReportSummaryHeroItem[];
  summaryLinks!: ReportSummaryLink[];
  sections!: ReportSection[];
  dates!: ReportDates | null;
  datesScope!: ReportDateScope | null;

  static override relations(): RelationConfig {
    return {
      filters: { type: ReportFilter },
      summaryItems: { type: ReportSummaryItem },
      summaryHeroItems: { type: ReportSummaryHeroItem },
      summaryLinks: { type: ReportSummaryLink },
      sections: { type: ReportSection },
      dates: { type: ReportDates },
      datesScope: { type: ReportDateScope },
    };
  }
}
